import { render, staticRenderFns } from "./PlanFeaturesExpasion.vue?vue&type=template&id=16e74451&scoped=true"
import script from "./PlanFeaturesExpasion.vue?vue&type=script&lang=js"
export * from "./PlanFeaturesExpasion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e74451",
  null
  
)

export default component.exports